import React from "react";
import * as io from "io-ts";
import createGlobalState from "../lib/createGlobalState";
import SearchInputV2 from "../Input/SearchInputV2";
import useFilteredDatas from "../lib/hooks/useFilteredDatas";
import { useDeferredValue } from "react";
import t from "../i18n";

const useTableSearch = createGlobalState({
  storage: "session",
  key: "table-search",
  type: io.string,
  defaultValue: "",
  scoped: true,
});

export function useTableSearchResults<T>({
  items,
  scope,
  index,
}: {
  items: T[];
  scope: string;
  index: (item: T) => string;
}): [T[], boolean] {
  const [search] = useTableSearch({ scope });
  const [data, isPending] = useFilteredDatas(
    items as Parameters<typeof useFilteredDatas>[0],
    search,
    index as Parameters<typeof useFilteredDatas>[2],
  );
  return [useDeferredValue(data) as T[], isPending];
}

export function TableSearch({ scope }: { scope: string }) {
  const [search, setSearch] = useTableSearch({ scope });

  return (
    <SearchInputV2
      placeholder={t("search")}
      onChange={e => setSearch(e.target.value)}
      value={search}
      slim
    />
  );
}
